var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectorRef, Component, ContentChild, ContentChildren, ElementRef, EventEmitter, HostBinding, HostListener, Injectable, Injector, Input, NgModule, Output, Pipe, Renderer2, TemplateRef, ViewChild, ViewChildren, animate, forwardRef, keyframes, state, style, transition, trigger } from '@angular/core';
import { COMPOSITION_BUFFER_MODE, FormControl, FormGroup, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Ng2Dropdown, Ng2DropdownModule } from 'ng2-material-dropdown';
import { Observable as Observable$1 } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/first';
import { animate as animate$1, keyframes as keyframes$1, state as state$1, style as style$1, transition as transition$1, trigger as trigger$1 } from '@angular/animations';
var escape = function (s) { return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'); };
var HighlightPipe = (function () {
    function HighlightPipe() {
    }
    /**
     * \@name transform
     * @param {?} value {string}
     * @param {?} arg {string}
     * @return {?}
     */
    HighlightPipe.prototype.transform = function (value, arg) {
        if (!arg.trim()) {
            return value;
        }
        try {
            var /** @type {?} */ regex = new RegExp("(" + escape(arg) + ")", 'i');
            return value.replace(regex, '<b>$1</b>');
        }
        catch (e) {
            return value;
        }
    };
    return HighlightPipe;
}());
HighlightPipe.decorators = [
    { type: Pipe, args: [{
                name: 'highlight'
            },] },
];
/**
 * @nocollapse
 */
HighlightPipe.ctorParameters = function () { return []; };
/*
** constants and default values for <tag-input>
 */
/*
** constants and default values for <tag-input>
 */ var PLACEHOLDER = '+ Tag';
var SECONDARY_PLACEHOLDER = 'Enter a new tag';
var KEYDOWN = 'keydown';
var KEYUP = 'keyup';
var MAX_ITEMS_WARNING = 'The number of items specified was greater than the property max-items.';
var ACTIONS_KEYS = {
    DELETE: 'DELETE',
    SWITCH_PREV: 'SWITCH_PREV',
    SWITCH_NEXT: 'SWITCH_NEXT',
    TAB: 'TAB'
};
var KEY_PRESS_ACTIONS = {
    8: ACTIONS_KEYS.DELETE,
    37: ACTIONS_KEYS.SWITCH_PREV,
    39: ACTIONS_KEYS.SWITCH_NEXT,
    9: ACTIONS_KEYS.TAB
};
var DRAG_AND_DROP_KEY = 'Text';
var NEXT = 'NEXT';
var PREV = 'PREV';
var DragProvider = (function () {
    function DragProvider() {
        this.state = {
            dragging: false,
            dropping: false,
            index: undefined
        };
    }
    /**
     * \@name setDraggedItem
     * @param {?} event
     * @param {?} tag
     * @return {?}
     */
    DragProvider.prototype.setDraggedItem = function (event, tag) {
        event.dataTransfer.setData(DRAG_AND_DROP_KEY, JSON.stringify(tag));
    };
    /**
     * \@name getDraggedItem
     * @param {?} event
     * @return {?}
     */
    DragProvider.prototype.getDraggedItem = function (event) {
        var /** @type {?} */ data = event.dataTransfer.getData(DRAG_AND_DROP_KEY);
        return (JSON.parse(data));
    };
    /**
     * \@name setSender
     * @param {?} sender
     * @return {?}
     */
    DragProvider.prototype.setSender = function (sender) {
        this.sender = sender;
    };
    /**
     * \@name setReceiver
     * @param {?} receiver
     * @return {?}
     */
    DragProvider.prototype.setReceiver = function (receiver) {
        this.receiver = receiver;
    };
    /**
     * \@name onTagDropped
     * @param {?} tag
     * @param {?} indexDragged
     * @param {?} indexDropped
     * @return {?}
     */
    DragProvider.prototype.onTagDropped = function (tag, indexDragged, indexDropped) {
        this.onDragEnd();
        this.sender.onRemoveRequested(tag, indexDragged);
        this.receiver.onAddingRequested(false, tag, indexDropped);
    };
    /**
     * \@name setState
     * @param {?} state
     * @return {?}
     */
    DragProvider.prototype.setState = function (state$$1) {
        this.state = Object.assign({}, this.state, state$$1);
    };
    /**
     * \@name getState
     * @param {?=} key
     * @return {?}
     */
    DragProvider.prototype.getState = function (key) {
        return key ? this.state[key] : this.state;
    };
    /**
     * \@name onDragEnd
     * @return {?}
     */
    DragProvider.prototype.onDragEnd = function () {
        this.setState({
            dragging: false,
            dropping: false,
            index: undefined
        });
    };
    return DragProvider;
}());
DragProvider.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
DragProvider.ctorParameters = function () { return []; };
var defaults = {
    tagInput: /** @type {?} */ ({
        separatorKeys: [],
        separatorKeyCodes: [],
        maxItems: Infinity,
        placeholder: PLACEHOLDER,
        secondaryPlaceholder: SECONDARY_PLACEHOLDER,
        validators: [],
        asyncValidators: [],
        onlyFromAutocomplete: false,
        errorMessages: {},
        theme: '',
        onTextChangeDebounce: 250,
        inputId: '',
        inputClass: '',
        clearOnBlur: false,
        hideForm: false,
        addOnBlur: false,
        addOnPaste: false,
        pasteSplitPattern: ',',
        blinkIfDupe: true,
        removable: true,
        editable: false,
        allowDupes: false,
        modelAsStrings: false,
        trimTags: true,
        ripple: true,
        tabIndex: '',
        disable: false,
        dragZone: '',
        onRemoving: undefined,
        onAdding: undefined,
        displayBy: 'display',
        identifyBy: 'value',
        animationDuration: {
            enter: "250ms",
            leave: "150ms"
        }
    }),
    dropdown: /** @type {?} */ ({
        displayBy: 'display',
        identifyBy: 'value',
        appendToBody: true,
        offset: '50 0',
        focusFirstElement: false,
        showDropdownIfEmpty: false,
        minimumTextLength: 1,
        limitItemsTo: Infinity,
        keepOpen: true,
        matchingFn: matchingFn
    })
};
/**
 * \@name matchingFn
 * @this {?}
 * @param {?} value
 * @param {?} target
 * @return {?}
 */
function matchingFn(value, target) {
    var /** @type {?} */ targetValue = target[this.displayBy].toString();
    return targetValue && targetValue
        .toLowerCase()
        .indexOf(value.toLowerCase()) >= 0;
}
var OptionsProvider = (function () {
    function OptionsProvider() {
    }
    /**
     * @param {?} options
     * @return {?}
     */
    OptionsProvider.prototype.setOptions = function (options) {
        OptionsProvider.defaults.tagInput = Object.assign({}, defaults.tagInput, options.tagInput);
        OptionsProvider.defaults.dropdown = Object.assign({}, defaults.dropdown, options.dropdown);
    };
    return OptionsProvider;
}());
OptionsProvider.defaults = defaults;
/**
 * @param {?} obj
 * @return {?}
 */
function isObject(obj) {
    return obj === Object(obj);
}
var TagInputAccessor = (function () {
    function TagInputAccessor() {
        this._items = [];
        /**
         * \@name displayBy
         */
        this.displayBy = OptionsProvider.defaults.tagInput.displayBy;
        /**
         * \@name identifyBy
         */
        this.identifyBy = OptionsProvider.defaults.tagInput.identifyBy;
    }
    Object.defineProperty(TagInputAccessor.prototype, "items", {
        /**
         * @return {?}
         */
        get: function () {
            return this._items;
        },
        /**
         * @param {?} items
         * @return {?}
         */
        set: function (items) {
            this._items = items;
            this._onChangeCallback(this._items);
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    TagInputAccessor.prototype.onTouched = function () {
        this._onTouchedCallback();
    };
    /**
     * @param {?} items
     * @return {?}
     */
    TagInputAccessor.prototype.writeValue = function (items) {
        this._items = items || [];
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TagInputAccessor.prototype.registerOnChange = function (fn) {
        this._onChangeCallback = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TagInputAccessor.prototype.registerOnTouched = function (fn) {
        this._onTouchedCallback = fn;
    };
    /**
     * \@name getItemValue
     * @param {?} item
     * @return {?}
     */
    TagInputAccessor.prototype.getItemValue = function (item) {
        return isObject(item) ? item[this.identifyBy] : item;
    };
    /**
     * \@name getItemDisplay
     * @param {?} item
     * @return {?}
     */
    TagInputAccessor.prototype.getItemDisplay = function (item) {
        return isObject(item) ? item[this.displayBy] : item;
    };
    /**
     * \@name getItemsWithout
     * @param {?} index
     * @return {?}
     */
    TagInputAccessor.prototype.getItemsWithout = function (index) {
        return this.items.filter(function (item, position) { return position !== index; });
    };
    return TagInputAccessor;
}());
TagInputAccessor.propDecorators = {
    'displayBy': [{ type: Input },],
    'identifyBy': [{ type: Input },],
};
/**
 * \@name listen
 * @param {?} listenerType
 * @param {?} action
 * @param {?=} condition
 * @return {?}
 */
function listen(listenerType, action, condition) {
    if (condition === void 0) { condition = true; }
    // if the event provided does not exist, throw an error
    if (!this.listeners.hasOwnProperty(listenerType)) {
        throw new Error('The event entered may be wrong');
    }
    // if a condition is present and is false, exit early
    if (!condition) {
        return;
    }
    // fire listener
    this.listeners[listenerType].push(action);
}
var TagInputForm = (function () {
    function TagInputForm() {
        /**
         * \@name onSubmit
         */
        this.onSubmit = new EventEmitter();
        /**
         * \@name onBlur
         */
        this.onBlur = new EventEmitter();
        /**
         * \@name onFocus
         */
        this.onFocus = new EventEmitter();
        /**
         * \@name onKeyup
         */
        this.onKeyup = new EventEmitter();
        /**
         * \@name onKeydown
         */
        this.onKeydown = new EventEmitter();
        /**
         * \@name validators
         */
        this.validators = [];
        /**
         * \@name asyncValidators
         * @desc array of AsyncValidator that are used to validate the tag before it gets appended to the list
         */
        this.asyncValidators = [];
        /**
         * \@name tabindex
         * @desc pass through the specified tabindex to the input
         */
        this.tabindex = '';
        /**
         * \@name disabled
         */
        this.disabled = false;
        /**
         * \@name inputTextChange
         */
        this.inputTextChange = new EventEmitter();
        /**
         * \@name inputTextValue
         */
        this.inputTextValue = '';
    }
    Object.defineProperty(TagInputForm.prototype, "inputText", {
        /**
         * \@name inputText
         * @return {?}
         */
        get: function () {
            return this.inputTextValue;
        },
        /**
         * \@name inputText
         * @param {?} text {string}
         * @return {?}
         */
        set: function (text) {
            this.inputTextValue = text;
            this.inputTextChange.emit(text);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    TagInputForm.prototype.ngOnInit = function () {
        // creating form
        this.form = new FormGroup({
            item: new FormControl({ value: '', disabled: this.disabled }, this.validators, this.asyncValidators)
        });
    };
    Object.defineProperty(TagInputForm.prototype, "value", {
        /**
         * \@name value
         * @return {?}
         */
        get: function () {
            return this.form.get('item');
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@name isInputFocused
     * @return {?}
     */
    TagInputForm.prototype.isInputFocused = function () {
        return document.activeElement === this.input.nativeElement;
    };
    /**
     * \@name getErrorMessages
     * @param {?} messages
     * @return {?}
     */
    TagInputForm.prototype.getErrorMessages = function (messages) {
        var /** @type {?} */ value = this.value;
        return value ? Object.keys(messages)
            .filter(function (err) { return value.hasError(err); })
            .map(function (err) { return messages[err]; }) : [];
    };
    /**
     * \@name hasErrors
     * @return {?}
     */
    TagInputForm.prototype.hasErrors = function () {
        return this.form.dirty &&
            this.form.value.item &&
            this.form.invalid;
    };
    /**
     * \@name focus
     * @return {?}
     */
    TagInputForm.prototype.focus = function () {
        this.input.nativeElement.focus();
    };
    /**
     * \@name blur
     * @return {?}
     */
    TagInputForm.prototype.blur = function () {
        this.input.nativeElement.blur();
    };
    /**
     * \@name getElementPosition
     * @return {?}
     */
    TagInputForm.prototype.getElementPosition = function () {
        return this.input.nativeElement.getBoundingClientRect();
    };
    /**
     * - removes input from the component
     * \@name destroy
     * @return {?}
     */
    TagInputForm.prototype.destroy = function () {
        var /** @type {?} */ input = this.input.nativeElement;
        input.parentElement.removeChild(input);
    };
    /**
     * \@name onKeyDown
     * @param {?} $event
     * @return {?}
     */
    TagInputForm.prototype.onKeyDown = function ($event) {
        return this.onKeydown.emit($event);
    };
    /**
     * \@name submit
     * @param {?} $event
     * @return {?}
     */
    TagInputForm.prototype.submit = function ($event) {
        this.onSubmit.emit($event);
    };
    return TagInputForm;
}());
TagInputForm.decorators = [
    { type: Component, args: [{
                selector: 'tag-input-form',
                styles: ["\n      .dark tag:focus {\n        -webkit-box-shadow: 0 0 0 1px #323232;\n                box-shadow: 0 0 0 1px #323232; }\n\n      .ng2-tag-input.bootstrap3-info {\n        background-color: #fff;\n        display: inline-block;\n        color: #555;\n        vertical-align: middle;\n        max-width: 100%;\n        height: 42px;\n        line-height: 44px; }\n\n      .ng2-tag-input.bootstrap3-info input {\n        border: none;\n        -webkit-box-shadow: none;\n                box-shadow: none;\n        outline: none;\n        background-color: transparent;\n        padding: 0 6px;\n        margin: 0;\n        width: auto;\n        max-width: inherit; }\n\n      .ng2-tag-input.bootstrap3-info .form-control input::-moz-placeholder {\n        color: #777;\n        opacity: 1; }\n\n      .ng2-tag-input.bootstrap3-info .form-control input:-ms-input-placeholder {\n        color: #777; }\n\n      .ng2-tag-input.bootstrap3-info .form-control input::-webkit-input-placeholder {\n        color: #777; }\n\n      .ng2-tag-input.bootstrap3-info input:focus {\n        border: none;\n        -webkit-box-shadow: none;\n                box-shadow: none; }\n\n      .bootstrap3-info.ng2-tag-input.ng2-tag-input--focused {\n        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n                box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n        border: 1px solid #ccc; }\n\n      .bootstrap3-info.ng2-tag-input.ng2-tag-input--invalid {\n        -webkit-box-shadow: inset 0 1px 1px #d9534f;\n                box-shadow: inset 0 1px 1px #d9534f; }\n\n      .ng2-tag-input {\n        display: block;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        position: relative;\n        -webkit-transition: all 0.25s;\n        transition: all 0.25s;\n        padding: 0.25rem 0;\n        min-height: 32px;\n        cursor: text;\n        border-bottom: 2px solid #efefef; }\n        .ng2-tag-input:focus {\n          outline: 0; }\n        .ng2-tag-input.ng2-tag-input--dropping {\n          opacity: 0.7; }\n        .ng2-tag-input.ng2-tag-input--focused {\n          border-bottom: 2px solid #2196F3; }\n        .ng2-tag-input.ng2-tag-input--invalid {\n          border-bottom: 2px solid #f44336; }\n        .ng2-tag-input.ng2-tag-input--loading {\n          border: none; }\n        .ng2-tag-input.ng2-tag-input--disabled {\n          opacity: 0.5;\n          cursor: not-allowed; }\n        .ng2-tag-input form {\n          margin: 0.1em 0; }\n        .ng2-tag-input .ng2-tags-container {\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex; }\n\n      .minimal.ng2-tag-input {\n        display: block;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        position: relative;\n        cursor: text;\n        border-bottom: 1px solid transparent; }\n        .minimal.ng2-tag-input:focus {\n          outline: 0; }\n        .minimal.ng2-tag-input.ng2-tag-input--dropping {\n          opacity: 0.7; }\n        .minimal.ng2-tag-input.ng2-tag-input--loading {\n          border: none; }\n        .minimal.ng2-tag-input.ng2-tag-input--disabled {\n          opacity: 0.5;\n          cursor: not-allowed; }\n        .minimal.ng2-tag-input .ng2-tags-container {\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex; }\n\n      .dark.ng2-tag-input {\n        display: block;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        position: relative;\n        cursor: text;\n        border-bottom: 2px solid #444; }\n        .dark.ng2-tag-input:focus {\n          outline: 0; }\n        .dark.ng2-tag-input.ng2-tag-input--dropping {\n          opacity: 0.7; }\n        .dark.ng2-tag-input.ng2-tag-input--loading {\n          border: none; }\n        .dark.ng2-tag-input.ng2-tag-input--disabled {\n          opacity: 0.5;\n          cursor: not-allowed; }\n        .dark.ng2-tag-input .ng2-tags-container {\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex; }\n\n      .bootstrap.ng2-tag-input {\n        display: block;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        position: relative;\n        cursor: text;\n        border-bottom: 2px solid #efefef; }\n        .bootstrap.ng2-tag-input:focus {\n          outline: 0; }\n        .bootstrap.ng2-tag-input.ng2-tag-input--dropping {\n          opacity: 0.7; }\n        .bootstrap.ng2-tag-input.ng2-tag-input--focused {\n          border-bottom: 2px solid #0275d8; }\n        .bootstrap.ng2-tag-input.ng2-tag-input--invalid {\n          border-bottom: 2px solid #d9534f; }\n        .bootstrap.ng2-tag-input.ng2-tag-input--loading {\n          border: none; }\n        .bootstrap.ng2-tag-input.ng2-tag-input--disabled {\n          opacity: 0.5;\n          cursor: not-allowed; }\n        .bootstrap.ng2-tag-input .ng2-tags-container {\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex; }\n\n      .bootstrap3-info.ng2-tag-input {\n        display: block;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        position: relative;\n        padding: 4px;\n        cursor: text;\n        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n                box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n        border-radius: 4px; }\n        .bootstrap3-info.ng2-tag-input:focus {\n          outline: 0; }\n        .bootstrap3-info.ng2-tag-input.ng2-tag-input--dropping {\n          opacity: 0.7; }\n        .bootstrap3-info.ng2-tag-input.ng2-tag-input--invalid {\n          border-bottom: 1px solid #d9534f; }\n        .bootstrap3-info.ng2-tag-input.ng2-tag-input--loading {\n          border: none; }\n        .bootstrap3-info.ng2-tag-input.ng2-tag-input--disabled {\n          opacity: 0.5;\n          cursor: not-allowed; }\n        .bootstrap3-info.ng2-tag-input form {\n          margin: 0.1em 0; }\n        .bootstrap3-info.ng2-tag-input .ng2-tags-container {\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex; }\n\n      .error-message {\n        font-size: 0.8em;\n        color: #f44336;\n        margin: 0.5em 0 0 0; }\n\n      .bootstrap .error-message {\n        color: #d9534f; }\n\n      .ng2-tag-input__text-input {\n        display: inline;\n        vertical-align: middle;\n        border: none;\n        padding: 0 0.5rem;\n        height: 38px;\n        font-size: 1em;\n        font-family: \"Roboto\", \"Helvetica Neue\", sans-serif; }\n        .ng2-tag-input__text-input:focus {\n          outline: 0; }\n        .ng2-tag-input__text-input[disabled=true] {\n          opacity: 0.5;\n          background: #fff; }\n    "],
                template: "\n      <!-- form -->\n      <form (submit)=\"submit($event)\" [formGroup]=\"form\">\n          <input #input\n\n                 type=\"text\"\n                 class=\"ng2-tag-input__text-input\"\n                 autocomplete=\"off\"\n                 tabindex=\"{{ disabled ? -1 : tabindex ? tabindex : 0 }}\"\n                 minlength=\"1\"\n\n                 [(ngModel)]=\"inputText\"\n                 [formControlName]=\"'item'\"\n                 [ngClass]=\"inputClass\"\n                 [attr.id]=\"inputId\"\n                 [attr.placeholder]=\"placeholder\"\n                 [attr.aria-label]=\"placeholder\"\n                 [attr.tabindex]=\"tabindex\"\n                 [attr.disabled]=\"disabled ? disabled : null\"\n\n                 (focus)=\"onFocus.emit($event)\"\n                 (blur)=\"onBlur.emit($event)\"\n                 (keydown)=\"onKeyDown($event)\"\n                 (keyup)=\"onKeyup.emit($event)\"\n          />\n      </form>\n    "
            },] },
];
/**
 * @nocollapse
 */
TagInputForm.ctorParameters = function () { return []; };
TagInputForm.propDecorators = {
    'onSubmit': [{ type: Output },],
    'onBlur': [{ type: Output },],
    'onFocus': [{ type: Output },],
    'onKeyup': [{ type: Output },],
    'onKeydown': [{ type: Output },],
    'placeholder': [{ type: Input },],
    'validators': [{ type: Input },],
    'asyncValidators': [{ type: Input },],
    'inputId': [{ type: Input },],
    'inputClass': [{ type: Input },],
    'inputText': [{ type: Input },],
    'tabindex': [{ type: Input },],
    'disabled': [{ type: Input },],
    'input': [{ type: ViewChild, args: ['input',] },],
    'inputTextChange': [{ type: Output },],
};
var defaults$2 = forwardRef(function () { return OptionsProvider.defaults.dropdown; });
var TagInputDropdown = (function () {
    /**
     * @param {?} injector
     */
    function TagInputDropdown(injector) {
        var _this = this;
        this.injector = injector;
        /**
         * \@name offset
         */
        this.offset = new defaults$2().offset;
        /**
         * \@name focusFirstElement
         */
        this.focusFirstElement = new defaults$2().focusFirstElement;
        /**
         * - show autocomplete dropdown if the value of input is empty
         * \@name showDropdownIfEmpty
         */
        this.showDropdownIfEmpty = new defaults$2().showDropdownIfEmpty;
        /**
         * - desc minimum text length in order to display the autocomplete dropdown
         * \@name minimumTextLength
         */
        this.minimumTextLength = new defaults$2().minimumTextLength;
        /**
         * - number of items to display in the autocomplete dropdown
         * \@name limitItemsTo
         */
        this.limitItemsTo = new defaults$2().limitItemsTo;
        /**
         * \@name displayBy
         */
        this.displayBy = new defaults$2().displayBy;
        /**
         * \@name identifyBy
         */
        this.identifyBy = new defaults$2().identifyBy;
        /**
         * \@description a function a developer can use to implement custom matching for the autocomplete
         * \@name matchingFn
         */
        this.matchingFn = new defaults$2().matchingFn;
        /**
         * \@name appendToBody
         */
        this.appendToBody = new defaults$2().appendToBody;
        /**
         * \@name keepOpen
         * \@description option to leave dropdown open when adding a new item
         */
        this.keepOpen = new defaults$2().keepOpen;
        /**
         * list of items that match the current value of the input (for autocomplete)
         * \@name items
         */
        this.items = [];
        /**
         * \@name tagInput
         */
        this.tagInput = this.injector.get(TagInputComponent);
        /**
         * \@name _autocompleteItems
         */
        this._autocompleteItems = [];
        /**
         *
         * \@name show
         */
        this.show = function () {
            var maxItemsReached = _this.tagInput.items.length === _this.tagInput.maxItems;
            var value = _this.getFormValue();
            var hasMinimumText = value.trim().length >= _this.minimumTextLength;
            var position = _this.calculatePosition();
            var items = _this.getMatchingItems(value);
            var hasItems = items.length > 0;
            var isHidden = _this.isVisible === false;
            var showDropdownIfEmpty = _this.showDropdownIfEmpty && hasItems && !value;
            var shouldShow = isHidden && ((hasItems && hasMinimumText) || showDropdownIfEmpty);
            var shouldHide = _this.isVisible && !hasItems;
            if (_this.autocompleteObservable && hasMinimumText) {
                return _this.getItemsFromObservable(value);
            }
            if (!_this.showDropdownIfEmpty && !value) {
                return _this.dropdown.hide();
            }
            if (maxItemsReached) {
                return _this.dropdown.hide();
            }
            _this.setItems(items);
            if (shouldShow) {
                _this.dropdown.show(position);
            }
            else if (shouldHide) {
                _this.hide();
            }
        };
        /**
         * \@name requestAdding
         * @param item {Ng2MenuItem}
         */
        this.requestAdding = function (item) {
            _this.tagInput.onAddingRequested(true, _this.createTagModel(item));
        };
        /**
         * \@name resetItems
         */
        this.resetItems = function () {
            _this.items = [];
        };
        /**
         * \@name getItemsFromObservable
         * @param text
         */
        this.getItemsFromObservable = function (text) {
            _this.setLoadingState(true);
            var subscribeFn = function (data) {
                // hide loading animation
                _this.setLoadingState(false)
                    .populateItems(data);
                _this.setItems(_this.getMatchingItems(text));
                if (_this.items.length) {
                    _this.dropdown.show(_this.calculatePosition());
                }
                else if (!_this.showDropdownIfEmpty && _this.isVisible) {
                    _this.dropdown.hide();
                }
            };
            _this.autocompleteObservable(text)
                .first()
                .subscribe(subscribeFn, function () { return _this.setLoadingState(false); });
        };
    }
    Object.defineProperty(TagInputDropdown.prototype, "autocompleteItems", {
        /**
         * \@name autocompleteItems
         * @desc array of items that will populate the autocomplete
         * @return {?}
         */
        get: function () {
            var _this = this;
            var /** @type {?} */ items = this._autocompleteItems;
            if (!items) {
                return [];
            }
            return items.map(function (item) {
                return typeof item === 'string' ? (_a = {},
                    _a[_this.displayBy] = item,
                    _a[_this.identifyBy] = item,
                    _a) : item;
                var _a;
            });
        },
        /**
         * \@name autocompleteItems
         * @param {?} items
         * @return {?}
         */
        set: function (items) {
            this._autocompleteItems = items;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@name ngOnInit
     * @return {?}
     */
    TagInputDropdown.prototype.ngOnInit = function () {
        this.onItemClicked().subscribe(this.requestAdding);
        // reset itemsMatching array when the dropdown is hidden
        this.onHide().subscribe(this.resetItems);
        var /** @type {?} */ DEBOUNCE_TIME = 200;
        var /** @type {?} */ KEEP_OPEN = this.keepOpen;
        this.tagInput
            .onTextChange
            .asObservable()
            .debounceTime(DEBOUNCE_TIME)
            .filter(function (value) {
            if (KEEP_OPEN === false) {
                return value.length > 0;
            }
            return true;
        })
            .subscribe(this.show);
    };
    /**
     * \@name updatePosition
     * @return {?}
     */
    TagInputDropdown.prototype.updatePosition = function () {
        var /** @type {?} */ position = this.tagInput.inputForm.getElementPosition();
        this.dropdown.menu.updatePosition(position);
    };
    Object.defineProperty(TagInputDropdown.prototype, "isVisible", {
        /**
         * \@name isVisible
         * @return {?}
         */
        get: function () {
            return this.dropdown.menu.state.menuState.isVisible;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@name onHide
     * @return {?}
     */
    TagInputDropdown.prototype.onHide = function () {
        return this.dropdown.onHide;
    };
    /**
     * \@name onItemClicked
     * @return {?}
     */
    TagInputDropdown.prototype.onItemClicked = function () {
        return this.dropdown.onItemClicked;
    };
    Object.defineProperty(TagInputDropdown.prototype, "selectedItem", {
        /**
         * \@name selectedItem
         * @return {?}
         */
        get: function () {
            return this.dropdown.menu.state.dropdownState.selectedItem;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TagInputDropdown.prototype, "state", {
        /**
         * \@name state
         * @return {?}
         */
        get: function () {
            return this.dropdown.menu.state;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@name hide
     * @return {?}
     */
    TagInputDropdown.prototype.hide = function () {
        this.resetItems();
        this.dropdown.hide();
    };
    /**
     * \@name scrollListener
     * @return {?}
     */
    TagInputDropdown.prototype.scrollListener = function () {
        if (!this.isVisible) {
            return;
        }
        this.updatePosition();
    };
    /**
     * \@name onWindowBlur
     * @return {?}
     */
    TagInputDropdown.prototype.onWindowBlur = function () {
        this.dropdown.hide();
    };
    /**
     * \@name getFormValue
     * @return {?}
     */
    TagInputDropdown.prototype.getFormValue = function () {
        return this.tagInput.formValue.trim();
    };
    /**
     * \@name calculatePosition
     * @return {?}
     */
    TagInputDropdown.prototype.calculatePosition = function () {
        return this.tagInput.inputForm.getElementPosition();
    };
    /**
     * \@name createTagModel
     * @param {?} item
     * @return {?}
     */
    TagInputDropdown.prototype.createTagModel = function (item) {
        var /** @type {?} */ display = typeof item.value === 'string' ? item.value : item.value[this.displayBy];
        var /** @type {?} */ value = typeof item.value === 'string' ? item.value : item.value[this.identifyBy];
        return Object.assign({}, item.value, (_a = {}, _a[this.tagInput.displayBy] = display, _a[this.tagInput.identifyBy] = value, _a));
        var _a;
    };
    /**
     *
     * @param {?} value {string}
     * @return {?}
     */
    TagInputDropdown.prototype.getMatchingItems = function (value) {
        var _this = this;
        if (!value && !this.showDropdownIfEmpty) {
            return [];
        }
        var /** @type {?} */ dupesAllowed = this.tagInput.allowDupes;
        return this.autocompleteItems.filter(function (item) {
            var /** @type {?} */ hasValue = dupesAllowed ? false : _this.tagInput.tags.some(function (tag) {
                var /** @type {?} */ identifyBy = _this.tagInput.identifyBy;
                var /** @type {?} */ model = typeof tag.model === 'string' ? tag.model : tag.model[identifyBy];
                return model === item[_this.identifyBy];
            });
            return _this.matchingFn(value, item) && (hasValue === false);
        });
    };
    /**
     * \@name setItems
     * @param {?} items
     * @return {?}
     */
    TagInputDropdown.prototype.setItems = function (items) {
        this.items = items.slice(0, this.limitItemsTo || items.length);
    };
    /**
     * \@name populateItems
     * @param {?} data
     * @return {?}
     */
    TagInputDropdown.prototype.populateItems = function (data) {
        var _this = this;
        this.autocompleteItems = data.map(function (item) {
            return typeof item === 'string' ? (_a = {},
                _a[_this.displayBy] = item,
                _a[_this.identifyBy] = item,
                _a) : item;
            var _a;
        });
        return this;
    };
    /**
     * \@name setLoadingState
     * @param {?} state
     * @return {?}
     */
    TagInputDropdown.prototype.setLoadingState = function (state$$1) {
        this.tagInput.isLoading = state$$1;
        return this;
    };
    return TagInputDropdown;
}());
TagInputDropdown.decorators = [
    { type: Component, args: [{
                selector: 'tag-input-dropdown',
                template: "\n      <ng2-dropdown>\n          <ng2-dropdown-menu [focusFirstElement]=\"focusFirstElement\"\n                             [appendToBody]=\"appendToBody\"\n                             [offset]=\"offset\">\n              <ng2-menu-item *ngFor=\"let item of items; let index = index; let last = last\"\n                             [value]=\"item\"\n                             [ngSwitch]=\"!!templates.length\">\n\n                  <span *ngSwitchCase=\"false\"\n                        [innerHTML]=\"item[displayBy] | highlight : tagInput.inputForm.value.value\">\n                  </span>\n\n                  <ng-template *ngSwitchDefault\n                            [ngTemplateOutlet]=\"templates.first\"\n                            [ngTemplateOutletContext]=\"{ item: item, index: index, last: last }\">\n                  </ng-template>\n              </ng2-menu-item>\n          </ng2-dropdown-menu>\n      </ng2-dropdown>\n    "
            },] },
];
/**
 * @nocollapse
 */
TagInputDropdown.ctorParameters = function () { return [
    { type: Injector, },
]; };
TagInputDropdown.propDecorators = {
    'dropdown': [{ type: ViewChild, args: [Ng2Dropdown,] },],
    'templates': [{ type: ContentChildren, args: [TemplateRef,] },],
    'offset': [{ type: Input },],
    'focusFirstElement': [{ type: Input },],
    'showDropdownIfEmpty': [{ type: Input },],
    'autocompleteObservable': [{ type: Input },],
    'minimumTextLength': [{ type: Input },],
    'limitItemsTo': [{ type: Input },],
    'displayBy': [{ type: Input },],
    'identifyBy': [{ type: Input },],
    'matchingFn': [{ type: Input },],
    'appendToBody': [{ type: Input },],
    'keepOpen': [{ type: Input },],
    'autocompleteItems': [{ type: Input },],
    'scrollListener': [{ type: HostListener, args: ['window:scroll',] },],
    'onWindowBlur': [{ type: HostListener, args: ['window:blur',] },],
};
var TagRipple = (function () {
    function TagRipple() {
        this.state = 'none';
    }
    return TagRipple;
}());
TagRipple.decorators = [
    { type: Component, args: [{
                selector: 'tag-ripple',
                styles: ["\n        :host {\n            width: 100%;\n            height: 100%;\n            left: 0;\n            overflow: hidden;\n            position: absolute;\n        }\n        \n        .tag-ripple {\n            background: rgba(0, 0, 0, 0.1);\n            top: 50%;\n            left: 50%;\n            height: 100%;\n            transform: translate(-50%, -50%);\n            position: absolute;\n        }\n    "],
                template: "\n        <div class=\"tag-ripple\" [@ink]=\"state\"></div>\n    ",
                animations: [
                    trigger('ink', [
                        state('none', style({ width: 0, opacity: 0 })),
                        transition('none => clicked', [
                            animate(300, keyframes([
                                style({ opacity: 1, offset: 0, width: '30%', borderRadius: '100%' }),
                                style({ opacity: 1, offset: 0.5, width: '50%' }),
                                style({ opacity: 0.5, offset: 1, width: '100%', borderRadius: '16px' })
                            ]))
                        ])
                    ])
                ]
            },] },
];
/**
 * @nocollapse
 */
TagRipple.ctorParameters = function () { return []; };
TagRipple.propDecorators = {
    'state': [{ type: Input },],
};
// angular universal hacks
/* tslint:disable-next-line */
var KeyboardEvent = ((global)).KeyboardEvent;
var MouseEvent = ((global)).MouseEvent;
// mocking navigator
var navigator = typeof window !== 'undefined' ? window.navigator : {
    userAgent: 'Chrome',
    vendor: 'Google Inc'
};
var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
var TagComponent = (function () {
    /**
     * @param {?} element
     * @param {?} renderer
     * @param {?} cdRef
     */
    function TagComponent(element, renderer, cdRef) {
        this.element = element;
        this.renderer = renderer;
        this.cdRef = cdRef;
        /**
         * \@name disabled
         */
        this.disabled = false;
        /**
         * \@name onSelect
         */
        this.onSelect = new EventEmitter();
        /**
         * \@name onRemove
         */
        this.onRemove = new EventEmitter();
        /**
         * \@name onBlur
         */
        this.onBlur = new EventEmitter();
        /**
         * \@name onKeyDown
         */
        this.onKeyDown = new EventEmitter();
        /**
         * \@name onTagEdited
         */
        this.onTagEdited = new EventEmitter();
        /**
         * \@name editing
         */
        this.editing = false;
        /**
         * \@name rippleState
         */
        this.rippleState = 'none';
    }
    Object.defineProperty(TagComponent.prototype, "readonly", {
        /**
         * \@name readonly {boolean}
         * @return {?}
         */
        get: function () {
            return typeof this.model !== 'string' && this.model.readonly === true;
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * \@name select
     * @param {?=} $event
     * @return {?}
     */
    TagComponent.prototype.select = function ($event) {
        if (this.readonly || this.disabled) {
            return;
        }
        if ($event) {
            $event.stopPropagation();
        }
        this.focus();
        this.onSelect.emit(this.model);
    };
    /**
     * \@name remove
     * @param {?} $event
     * @return {?}
     */
    TagComponent.prototype.remove = function ($event) {
        $event.stopPropagation();
        this.onRemove.emit(this);
    };
    /**
     * \@name focus
     * @return {?}
     */
    TagComponent.prototype.focus = function () {
        this.element.nativeElement.focus();
    };
    /**
     * @return {?}
     */
    TagComponent.prototype.move = function () {
        this.moving = true;
    };
    /**
     * \@name keydown
     * @param {?} event
     * @return {?}
     */
    TagComponent.prototype.keydown = function (event) {
        if (this.editing) {
            event.keyCode === 13 ? this.disableEditMode(event) : undefined;
            return;
        }
        this.onKeyDown.emit({ event: event, model: this.model });
    };
    /**
     * \@name blink
     * @return {?}
     */
    TagComponent.prototype.blink = function () {
        var /** @type {?} */ classList = this.element.nativeElement.classList;
        classList.add('blink');
        setTimeout(function () { return classList.remove('blink'); }, 50);
    };
    /**
     * \@name toggleEditMode
     * @return {?}
     */
    TagComponent.prototype.toggleEditMode = function () {
        if (this.editable) {
            this.editing ? undefined : this.activateEditMode();
        }
    };
    /**
     * \@name onBlurred
     * @param {?} event
     * @return {?}
     */
    TagComponent.prototype.onBlurred = function (event) {
        // Checks if it is editable first before handeling the onBlurred event in order to prevent
        // a bug in IE where tags are still editable with onlyFromAutocomplete set to true
        if (!this.editable) {
            return;
        }
        this.disableEditMode();
        var /** @type {?} */ value = event.target.innerText;
        var /** @type {?} */ result = typeof this.model === 'string' ? value : Object.assign({}, this.model, (_a = {}, _a[this.displayBy] = value, _a));
        this.onBlur.emit(result);
        var _a;
    };
    /**
     * \@name getDisplayValue
     * @param {?} item
     * @return {?}
     */
    TagComponent.prototype.getDisplayValue = function (item) {
        return typeof item === 'string' ? item : item[this.displayBy];
    };
    Object.defineProperty(TagComponent.prototype, "isRippleVisible", {
        /**
         * @desc returns whether the ripple is visible or not
         * only works in Chrome
         * \@name isRippleVisible
         * @return {?}
         */
        get: function () {
            return !this.readonly &&
                !this.editing &&
                isChrome &&
                this.hasRipple;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@name disableEditMode
     * @param {?=} $event
     * @return {?}
     */
    TagComponent.prototype.disableEditMode = function ($event) {
        var /** @type {?} */ classList = this.element.nativeElement.classList;
        var /** @type {?} */ input = this.getContentEditableText();
        this.editing = false;
        classList.remove('tag--editing');
        if (!input) {
            this.setContentEditableText(this.model);
            return;
        }
        this.storeNewValue(input);
        this.cdRef.detectChanges();
        if ($event) {
            $event.preventDefault();
        }
    };
    /**
     * \@name isDeleteIconVisible
     * @return {?}
     */
    TagComponent.prototype.isDeleteIconVisible = function () {
        return !this.readonly &&
            !this.disabled &&
            this.removable &&
            !this.editing;
    };
    /**
     * \@name getContentEditableText
     * @return {?}
     */
    TagComponent.prototype.getContentEditableText = function () {
        var /** @type {?} */ input = this.getContentEditable();
        return input ? input.innerText.trim() : '';
    };
    /**
     * \@name setContentEditableText
     * @param {?} model
     * @return {?}
     */
    TagComponent.prototype.setContentEditableText = function (model) {
        var /** @type {?} */ input = this.getContentEditable();
        var /** @type {?} */ value = this.getDisplayValue(model);
        input.innerText = value;
    };
    /**
     * \@name
     * @return {?}
     */
    TagComponent.prototype.activateEditMode = function () {
        var /** @type {?} */ classList = this.element.nativeElement.classList;
        classList.add('tag--editing');
        this.editing = true;
    };
    /**
     * \@name storeNewValue
     * @param {?} input
     * @return {?}
     */
    TagComponent.prototype.storeNewValue = function (input) {
        var _this = this;
        var /** @type {?} */ exists = function (model) {
            return typeof model === 'string' ?
                model === input :
                model[_this.displayBy] === input;
        };
        var /** @type {?} */ hasId = function () {
            return _this.model[_this.identifyBy] !== _this.model[_this.displayBy];
        };
        // if the value changed, replace the value in the model
        if (exists(this.model)) {
            return;
        }
        var /** @type {?} */ model = typeof this.model === 'string' ? input : (_a = {},
            _a[this.identifyBy] = hasId() ? this.model[this.identifyBy] : input,
            _a[this.displayBy] = input,
            _a);
        // emit output
        this.model = model;
        this.onTagEdited.emit(model);
        var _a;
    };
    /**
     * \@name getContentEditable
     * @return {?}
     */
    TagComponent.prototype.getContentEditable = function () {
        return this.element.nativeElement.querySelector('[contenteditable]');
    };
    return TagComponent;
}());
TagComponent.decorators = [
    { type: Component, args: [{
                selector: 'tag',
                template: "\n      <div (click)=\"select($event)\"\n           (dblclick)=\"toggleEditMode()\"\n           (mousedown)=\"rippleState='clicked'\"\n           (mouseup)=\"rippleState='none'\"\n           [ngSwitch]=\"!!template\"\n           [class.disabled]=\"disabled\"\n           [attr.tabindex]=\"-1\"\n           [attr.aria-label]=\"getDisplayValue(model)\">\n\n          <div *ngSwitchCase=\"true\" [attr.contenteditable]=\"editing\">\n              <!-- CUSTOM TEMPLATE -->\n              <ng-template\n                  [ngTemplateOutletContext]=\"{ item: model, index: index }\"\n                  [ngTemplateOutlet]=\"template\">\n              </ng-template>\n          </div>\n\n          <div *ngSwitchCase=\"false\" class=\"tag-wrapper\">\n              <!-- TAG NAME -->\n              <div [attr.contenteditable]=\"editing\"\n                   [attr.title]=\"getDisplayValue(model)\"\n                   class=\"tag__text inline\"\n                   spellcheck=\"false\"\n                   (keydown.enter)=\"disableEditMode($event)\"\n                   (keydown.escape)=\"disableEditMode($event)\"\n                   (click)=\"editing ? $event.stopPropagation() : undefined\"\n                   (blur)=\"onBlurred($event)\">\n                  {{ getDisplayValue(model) }}\n              </div>\n\n              <!-- 'X' BUTTON -->\n              <delete-icon\n                  aria-label=\"Remove tag\"\n                  role=\"button\"\n                  (click)=\"remove($event)\"\n                  *ngIf=\"isDeleteIconVisible()\">\n              </delete-icon>\n          </div>\n      </div>\n\n      <tag-ripple [state]=\"rippleState\"\n                  [attr.tabindex]=\"-1\"\n                  *ngIf=\"isRippleVisible\">\n      </tag-ripple>\n    ",
                styles: ["\n      :host,\n      :host > div,\n      :host > div:focus {\n        outline: 0;\n        overflow: hidden;\n        -webkit-transition: opacity 1s;\n        transition: opacity 1s;\n        z-index: 1; }\n\n      :host {\n        max-width: 400px; }\n\n      :host.blink {\n        -webkit-animation: blink 0.3s normal forwards ease-in-out;\n        animation: blink 0.3s normal forwards ease-in-out; }\n\n      @-webkit-keyframes blink {\n        0% {\n          opacity: 0.3; } }\n\n      @keyframes blink {\n        0% {\n          opacity: 0.3; } }\n\n      :host .disabled {\n        cursor: not-allowed; }\n\n      :host [contenteditable='true'] {\n        outline: 0; }\n\n      .tag-wrapper {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex; }\n\n      .tag__text {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap; }\n    "]
            },] },
];
/**
 * @nocollapse
 */
TagComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
    { type: ChangeDetectorRef, },
]; };
TagComponent.propDecorators = {
    'model': [{ type: Input },],
    'removable': [{ type: Input },],
    'editable': [{ type: Input },],
    'template': [{ type: Input },],
    'displayBy': [{ type: Input },],
    'identifyBy': [{ type: Input },],
    'index': [{ type: Input },],
    'hasRipple': [{ type: Input },],
    'disabled': [{ type: Input },],
    'onSelect': [{ type: Output },],
    'onRemove': [{ type: Output },],
    'onBlur': [{ type: Output },],
    'onKeyDown': [{ type: Output },],
    'onTagEdited': [{ type: Output },],
    'moving': [{ type: HostBinding, args: ['class.moving',] },],
    'ripple': [{ type: ViewChild, args: [TagRipple,] },],
    'keydown': [{ type: HostListener, args: ['keydown', ['$event'],] },],
};
/**
 * \@name animations
 */
var animations$1 = [
    trigger$1('animation', [
        state$1('in', style$1({
            opacity: 1
        })),
        state$1('out', style$1({
            opacity: 0
        })),
        transition$1(':enter', [
            animate$1("{{ enter }}", keyframes$1([
                style$1({ opacity: 0, offset: 0, transform: 'translate(0px, 20px)' }),
                style$1({ opacity: 0.3, offset: 0.3, transform: 'translate(0px, -10px)' }),
                style$1({ opacity: 0.5, offset: 0.5, transform: 'translate(0px, 0px)' }),
                style$1({ opacity: 0.75, offset: 0.75, transform: 'translate(0px, 5px)' }),
                style$1({ opacity: 1, offset: 1, transform: 'translate(0px, 0px)' })
            ]))
        ]),
        transition$1(':leave', [
            animate$1("{{ leave }}", keyframes$1([
                style$1({ opacity: 1, transform: 'translateX(0)', offset: 0 }),
                style$1({ opacity: 1, transform: 'translateX(-15px)', offset: 0.7 }),
                style$1({ opacity: 0, transform: 'translateX(100%)', offset: 1.0 })
            ]))
        ])
    ])
];
// angular
// rx
// ng2-tag-input
// angular universal hacks
/* tslint:disable-next-line */
var DragEvent = ((global)).DragEvent;
var CUSTOM_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return TagInputComponent; }),
    multi: true
};
var defaults$1 = forwardRef(function () { return OptionsProvider.defaults.tagInput; });
var TagInputComponent = (function (_super) {
    __extends(TagInputComponent, _super);
    /**
     * @param {?} renderer
     * @param {?} dragProvider
     */
    function TagInputComponent(renderer, dragProvider) {
        var _this = _super.call(this) || this;
        _this.renderer = renderer;
        _this.dragProvider = dragProvider;
        /**
         * \@name separatorKeys
         * @desc keyboard keys with which a user can separate items
         */
        _this.separatorKeys = new defaults$1().separatorKeys;
        /**
         * \@name separatorKeyCodes
         * @desc keyboard key codes with which a user can separate items
         */
        _this.separatorKeyCodes = new defaults$1().separatorKeyCodes;
        /**
         * \@name placeholder
         * @desc the placeholder of the input text
         */
        _this.placeholder = new defaults$1().placeholder;
        /**
         * \@name secondaryPlaceholder
         * @desc placeholder to appear when the input is empty
         */
        _this.secondaryPlaceholder = new defaults$1().secondaryPlaceholder;
        /**
         * \@name maxItems
         * @desc maximum number of items that can be added
         */
        _this.maxItems = new defaults$1().maxItems;
        /**
         * \@name validators
         * @desc array of Validators that are used to validate the tag before it gets appended to the list
         */
        _this.validators = new defaults$1().validators;
        /**
         * \@name asyncValidators
         * @desc array of AsyncValidator that are used to validate the tag before it gets appended to the list
         */
        _this.asyncValidators = new defaults$1().asyncValidators;
        /**
         * - if set to true, it will only possible to add items from the autocomplete
         * \@name onlyFromAutocomplete
         */
        _this.onlyFromAutocomplete = new defaults$1().onlyFromAutocomplete;
        /**
         * \@name errorMessages
         */
        _this.errorMessages = new defaults$1().errorMessages;
        /**
         * \@name theme
         */
        _this.theme = new defaults$1().theme;
        /**
         * \@name onTextChangeDebounce
         */
        _this.onTextChangeDebounce = new defaults$1().onTextChangeDebounce;
        /**
         * - custom id assigned to the input
         * \@name id
         */
        _this.inputId = new defaults$1().inputId;
        /**
         * - custom class assigned to the input
         */
        _this.inputClass = new defaults$1().inputClass;
        /**
         * - option to clear text input when the form is blurred
         * \@name clearOnBlur
         */
        _this.clearOnBlur = new defaults$1().clearOnBlur;
        /**
         * - hideForm
         * \@name clearOnBlur
         */
        _this.hideForm = new defaults$1().hideForm;
        /**
         * \@name addOnBlur
         */
        _this.addOnBlur = new defaults$1().addOnBlur;
        /**
         * \@name addOnPaste
         */
        _this.addOnPaste = new defaults$1().addOnPaste;
        /**
         * - pattern used with the native method split() to separate patterns in the string pasted
         * \@name pasteSplitPattern
         */
        _this.pasteSplitPattern = new defaults$1().pasteSplitPattern;
        /**
         * \@name blinkIfDupe
         */
        _this.blinkIfDupe = new defaults$1().blinkIfDupe;
        /**
         * \@name removable
         */
        _this.removable = new defaults$1().removable;
        /**
         * \@name editable
         */
        _this.editable = new defaults$1().editable;
        /**
         * \@name allowDupes
         */
        _this.allowDupes = new defaults$1().allowDupes;
        /**
         * \@description if set to true, the newly added tags will be added as strings, and not objects
         * \@name modelAsStrings
         */
        _this.modelAsStrings = new defaults$1().modelAsStrings;
        /**
         * \@name trimTags
         */
        _this.trimTags = new defaults$1().trimTags;
        /**
         * \@name ripple
         */
        _this.ripple = new defaults$1().ripple;
        /**
         * \@name tabindex
         * @desc pass through the specified tabindex to the input
         */
        _this.tabindex = new defaults$1().tabIndex;
        /**
         * \@name disable
         */
        _this.disable = new defaults$1().disable;
        /**
         * \@name dragZone
         */
        _this.dragZone = new defaults$1().dragZone;
        /**
         * \@name onRemoving
         */
        _this.onRemoving = new defaults$1().onRemoving;
        /**
         * \@name onAdding
         */
        _this.onAdding = new defaults$1().onAdding;
        /**
         * \@name animationDuration
         */
        _this.animationDuration = new defaults$1().animationDuration;
        /**
         * \@name onAdd
         * @desc event emitted when adding a new item
         */
        _this.onAdd = new EventEmitter();
        /**
         * \@name onRemove
         * @desc event emitted when removing an existing item
         */
        _this.onRemove = new EventEmitter();
        /**
         * \@name onSelect
         * @desc event emitted when selecting an item
         */
        _this.onSelect = new EventEmitter();
        /**
         * \@name onFocus
         * @desc event emitted when the input is focused
         */
        _this.onFocus = new EventEmitter();
        /**
         * \@name onFocus
         * @desc event emitted when the input is blurred
         */
        _this.onBlur = new EventEmitter();
        /**
         * \@name onTextChange
         * @desc event emitted when the input value changes
         */
        _this.onTextChange = new EventEmitter();
        /**
         * - output triggered when text is pasted in the form
         * \@name onPaste
         */
        _this.onPaste = new EventEmitter();
        /**
         * - output triggered when tag entered is not valid
         * \@name onValidationError
         */
        _this.onValidationError = new EventEmitter();
        /**
         * - output triggered when tag is edited
         * \@name onTagEdited
         */
        _this.onTagEdited = new EventEmitter();
        /**
         * \@name isLoading
         */
        _this.isLoading = false;
        /**
         * \@name listeners
         * @desc array of events that get fired using \@fireEvents
         */
        _this.listeners = (_a = {},
            _a[KEYDOWN] = [],
            _a[KEYUP] = [],
            _a);
        /**
         * \@description emitter for the 2-way data binding inputText value
         * \@name inputTextChange
         */
        _this.inputTextChange = new EventEmitter();
        /**
         * \@description private variable to bind get/set
         * \@name inputTextValue
         */
        _this.inputTextValue = '';
        /**
         * \@name appendTag
         * @param tag {TagModel}
         */
        _this.appendTag = function (tag, index) {
            if (index === void 0) { index = _this.items.length; }
            var items = _this.items;
            var model = _this.modelAsStrings ? tag[_this.identifyBy] : tag;
            _this.items = items.slice(0, index).concat([
                model
            ], items.slice(index, items.length));
        };
        /**
         * \@name createTag
         * @param model
         */
        _this.createTag = function (model) {
            var trim = function (val, key) {
                return typeof val === 'string' ? val.trim() : val[key];
            };
            return Object.assign({}, typeof model !== 'string' ? model : {}, (_a = {}, _a[_this.displayBy] = _this.trimTags ? trim(model, _this.displayBy) : model, _a[_this.identifyBy] = _this.trimTags ? trim(model, _this.identifyBy) : model, _a));
            var _a;
        };
        /**
         * \@name onPasteCallback
         * @param data
         */
        _this.onPasteCallback = function (data) {
            var text = data.clipboardData.getData('text/plain');
            text.split(_this.pasteSplitPattern)
                .map(function (item) { return _this.createTag(item); })
                .forEach(function (item) { return _this.onAddingRequested(false, item); });
            _this.onPaste.emit(text);
            setTimeout(function () { return _this.setInputValue(''); }, 0);
        };
        return _this;
        var _a;
    }
    Object.defineProperty(TagInputComponent.prototype, "inputText", {
        /**
         * \@name inputText
         * @return {?}
         */
        get: function () {
            return this.inputTextValue;
        },
        /**
         * \@name inputText
         * @param {?} text
         * @return {?}
         */
        set: function (text) {
            this.inputTextValue = text;
            this.inputTextChange.emit(text);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TagInputComponent.prototype, "tabindexAttr", {
        /**
         * @desc removes the tab index if it is set - it will be passed through to the input
         * \@name tabindexAttr
         * @return {?}
         */
        get: function () {
            return this.tabindex !== '' ? '-1' : '';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@name ngAfterViewInit
     * @return {?}
     */
    TagInputComponent.prototype.ngAfterViewInit = function () {
        // set up listeners
        this.setUpKeypressListeners();
        this.setupSeparatorKeysListener();
        this.setUpInputKeydownListeners();
        if (this.onTextChange.observers.length) {
            this.setUpTextChangeSubscriber();
        }
        // if clear on blur is set to true, subscribe to the event and clear the text's form
        if (this.clearOnBlur || this.addOnBlur) {
            this.setUpOnBlurSubscriber();
        }
        // if addOnPaste is set to true, register the handler and add items
        if (this.addOnPaste) {
            this.setUpOnPasteListener();
        }
        // if hideForm is set to true, remove the input
        if (this.hideForm) {
            this.inputForm.destroy();
        }
    };
    /**
     * \@name ngOnInit
     * @return {?}
     */
    TagInputComponent.prototype.ngOnInit = function () {
        // if the number of items specified in the model is > of the value of maxItems
        // degrade gracefully and let the max number of items to be the number of items in the model
        // though, warn the user.
        var /** @type {?} */ hasReachedMaxItems = this.maxItems !== undefined &&
            this.items &&
            this.items.length > this.maxItems;
        if (hasReachedMaxItems) {
            this.maxItems = this.items.length;
            console.warn(MAX_ITEMS_WARNING);
        }
        // Setting editable to false to fix problem with tags in IE still being editable when
        // onlyFromAutocomplete is true
        this.editable = this.onlyFromAutocomplete ? false : this.editable;
        this.setAnimationMetadata();
    };
    /**
     * \@name onRemoveRequested
     * @param {?} tag
     * @param {?} index
     * @return {?}
     */
    TagInputComponent.prototype.onRemoveRequested = function (tag, index) {
        var _this = this;
        var /** @type {?} */ subscribeFn = function (model) { return _this.removeItem(model, index); };
        this.onRemoving ?
            this.onRemoving(tag)
                .first()
                .subscribe(subscribeFn) : subscribeFn(tag);
    };
    /**
     * \@name onAddingRequested
     * @param {?} fromAutocomplete {boolean}
     * @param {?} tag {TagModel}
     * @param {?=} index
     * @return {?}
     */
    TagInputComponent.prototype.onAddingRequested = function (fromAutocomplete, tag, index) {
        var _this = this;
        if (!tag) {
            return;
        }
        var /** @type {?} */ subscribeFn = function (model) {
            return _this.addItem(fromAutocomplete, model, index);
        };
        this.onAdding ?
            this.onAdding(tag)
                .first()
                .subscribe(subscribeFn) : subscribeFn(tag);
    };
    /**
     * \@name selectItem
     * @desc selects item passed as parameter as the selected tag
     * @param {?} item
     * @param {?=} emit
     * @return {?}
     */
    TagInputComponent.prototype.selectItem = function (item, emit) {
        if (emit === void 0) { emit = true; }
        var /** @type {?} */ isReadonly = item && typeof item !== 'string' && item.readonly;
        if (isReadonly || this.selectedTag === item) {
            return;
        }
        this.selectedTag = item;
        if (emit) {
            this.onSelect.emit(item);
        }
    };
    /**
     * \@name fireEvents
     * @desc goes through the list of the events for a given eventName, and fires each of them
     * @param {?} eventName
     * @param {?=} $event
     * @return {?}
     */
    TagInputComponent.prototype.fireEvents = function (eventName, $event) {
        var _this = this;
        this.listeners[eventName].forEach(function (listener) { return listener.call(_this, $event); });
    };
    /**
     * \@name handleKeydown
     * @desc handles action when the user hits a keyboard key
     * @param {?} data
     * @return {?}
     */
    TagInputComponent.prototype.handleKeydown = function (data) {
        var /** @type {?} */ event = data.event;
        var /** @type {?} */ key = event.keyCode || event.which;
        switch (KEY_PRESS_ACTIONS[key]) {
            case ACTIONS_KEYS.DELETE:
                if (this.selectedTag && this.removable) {
                    var /** @type {?} */ index = this.items.indexOf(this.selectedTag);
                    this.onRemoveRequested(this.selectedTag, index);
                }
                break;
            case ACTIONS_KEYS.SWITCH_PREV:
                this.moveToTag(data.model, PREV);
                break;
            case ACTIONS_KEYS.SWITCH_NEXT:
                this.moveToTag(data.model, NEXT);
                break;
            case ACTIONS_KEYS.TAB:
                this.moveToTag(data.model, NEXT);
                break;
            default:
                return;
        }
        // prevent default behaviour
        event.preventDefault();
    };
    /**
     * \@name setInputValue
     * @param {?} value
     * @return {?}
     */
    TagInputComponent.prototype.setInputValue = function (value) {
        var /** @type {?} */ control = this.getControl();
        // update form value with the transformed item
        control.setValue(value);
    };
    /**
     * \@name getControl
     * @return {?}
     */
    TagInputComponent.prototype.getControl = function () {
        return (this.inputForm.value);
    };
    /**
     * \@name focus
     * @param {?=} applyFocus
     * @param {?=} displayAutocomplete
     * @return {?}
     */
    TagInputComponent.prototype.focus = function (applyFocus, displayAutocomplete) {
        if (applyFocus === void 0) { applyFocus = false; }
        if (displayAutocomplete === void 0) { displayAutocomplete = false; }
        if (this.dragProvider.getState('dragging')) {
            return;
        }
        this.selectItem(undefined, false);
        if (applyFocus) {
            this.inputForm.focus();
            this.onFocus.emit(this.formValue);
        }
    };
    /**
     * \@name blur
     * @return {?}
     */
    TagInputComponent.prototype.blur = function () {
        this.onTouched();
        this.onBlur.emit(this.formValue);
    };
    /**
     * \@name hasErrors
     * @return {?}
     */
    TagInputComponent.prototype.hasErrors = function () {
        return this.inputForm && this.inputForm.hasErrors();
    };
    /**
     * \@name isInputFocused
     * @return {?}
     */
    TagInputComponent.prototype.isInputFocused = function () {
        return this.inputForm && this.inputForm.isInputFocused();
    };
    /**
     * - this is the one way I found to tell if the template has been passed and it is not
     * the template for the menu item
     * \@name hasCustomTemplate
     * @return {?}
     */
    TagInputComponent.prototype.hasCustomTemplate = function () {
        var /** @type {?} */ template = this.templates ? this.templates.first : undefined;
        var /** @type {?} */ menuTemplate = this.dropdown && this.dropdown.templates ?
            this.dropdown.templates.first : undefined;
        return Boolean(template && template !== menuTemplate);
    };
    Object.defineProperty(TagInputComponent.prototype, "maxItemsReached", {
        /**
         * \@name maxItemsReached
         * @return {?}
         */
        get: function () {
            return this.maxItems !== undefined &&
                this.items.length >= this.maxItems;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TagInputComponent.prototype, "formValue", {
        /**
         * \@name formValue
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ form = this.inputForm.value;
            return form ? form.value : '';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * 3
     * \@name onDragStarted
     * @param {?} event
     * @param {?} tag
     * @param {?} index
     * @return {?}
     */
    TagInputComponent.prototype.onDragStarted = function (event, tag, index) {
        event.stopPropagation();
        var /** @type {?} */ item = ({ zone: this.dragZone, tag: tag, index: index });
        this.dragProvider.setSender(this);
        this.dragProvider.setDraggedItem(event, item);
        this.dragProvider.setState({ dragging: true, index: index });
    };
    /**
     * \@name onDragOver
     * @param {?} event
     * @param {?=} index
     * @return {?}
     */
    TagInputComponent.prototype.onDragOver = function (event, index) {
        this.dragProvider.setState({ dropping: true });
        this.dragProvider.setReceiver(this);
        event.preventDefault();
    };
    /**
     * \@name onTagDropped
     * @param {?} event
     * @param {?} index
     * @return {?}
     */
    TagInputComponent.prototype.onTagDropped = function (event, index) {
        var /** @type {?} */ item = this.dragProvider.getDraggedItem(event);
        if (item.zone !== this.dragZone) {
            return;
        }
        this.dragProvider.onTagDropped(item.tag, item.index, index);
        event.preventDefault();
        event.stopPropagation();
    };
    /**
     * \@name isDropping
     * @return {?}
     */
    TagInputComponent.prototype.isDropping = function () {
        var /** @type {?} */ isReceiver = this.dragProvider.receiver === this;
        var /** @type {?} */ isDropping = this.dragProvider.getState('dropping');
        return Boolean(isReceiver && isDropping);
    };
    /**
     * \@name onTagBlurred
     * @param {?} changedElement {TagModel}
     * @param {?} index {number}
     * @return {?}
     */
    TagInputComponent.prototype.onTagBlurred = function (changedElement, index) {
        this.items[index] = changedElement;
        this.blur();
    };
    /**
     * \@name trackBy
     * @param {?} item
     * @return {?}
     */
    TagInputComponent.prototype.trackBy = function (item) {
        return item[this.identifyBy];
    };
    /**
     *
     * @param {?} tag
     * @param {?=} fromAutocomplete
     * @return {?}
     */
    TagInputComponent.prototype.isTagValid = function (tag, fromAutocomplete) {
        var _this = this;
        if (fromAutocomplete === void 0) { fromAutocomplete = false; }
        var /** @type {?} */ selectedItem = this.dropdown ? this.dropdown.selectedItem : undefined;
        if (selectedItem && !fromAutocomplete) {
            return false;
        }
        var /** @type {?} */ dupe = this.findDupe(tag, fromAutocomplete);
        // if so, give a visual cue and return false
        if (!this.allowDupes && dupe && this.blinkIfDupe) {
            var /** @type {?} */ model = this.tags.find(function (tag) {
                return _this.getItemValue(tag.model) === _this.getItemValue(dupe);
            });
            if (model) {
                model.blink();
            }
        }
        var /** @type {?} */ isFromAutocomplete = fromAutocomplete && this.onlyFromAutocomplete;
        var /** @type {?} */ assertions = [
            // 1. there must be no dupe OR dupes are allowed
            !dupe || this.allowDupes === true,
            // 2. check max items has not been reached
            this.maxItemsReached === false,
            // 3. check item comes from autocomplete or onlyFromAutocomplete is false
            ((isFromAutocomplete) || this.onlyFromAutocomplete === false)
        ];
        return assertions.filter(function (item) { return item; }).length === assertions.length;
    };
    /**
     * \@name moveToTag
     * @param {?} item
     * @param {?} direction
     * @return {?}
     */
    TagInputComponent.prototype.moveToTag = function (item, direction) {
        var /** @type {?} */ isLast = this.tags.last.model === item;
        var /** @type {?} */ isFirst = this.tags.first.model === item;
        var /** @type {?} */ stopSwitch = (direction === NEXT && isLast) ||
            (direction === PREV && isFirst);
        if (stopSwitch) {
            this.focus(true);
            return;
        }
        var /** @type {?} */ offset = direction === NEXT ? 1 : -1;
        var /** @type {?} */ index = this.getTagIndex(item) + offset;
        var /** @type {?} */ tag = this.getTagAtIndex(index);
        return tag.select.call(tag);
    };
    /**
     * \@name getTagIndex
     * @param {?} item
     * @return {?}
     */
    TagInputComponent.prototype.getTagIndex = function (item) {
        var /** @type {?} */ tags = this.tags.toArray();
        return tags.findIndex(function (tag) { return tag.model === item; });
    };
    /**
     * \@name getTagAtIndex
     * @param {?} index
     * @return {?}
     */
    TagInputComponent.prototype.getTagAtIndex = function (index) {
        var /** @type {?} */ tags = this.tags.toArray();
        return tags[index];
    };
    /**
     * \@name removeItem
     * @desc removes an item from the array of the model
     * @param {?} tag {TagModel}
     * @param {?} index {number}
     * @return {?}
     */
    TagInputComponent.prototype.removeItem = function (tag, index) {
        this.items = this.getItemsWithout(index);
        // if the removed tag was selected, set it as undefined
        if (this.selectedTag === tag) {
            this.selectItem(undefined, false);
        }
        // focus input
        this.focus(true, false);
        // emit remove event
        this.onRemove.emit(tag);
    };
    /**
     * \@name addItem
     * @desc adds the current text model to the items array
     * @param {?=} fromAutocomplete
     * @param {?=} item
     * @param {?=} index
     * @return {?}
     */
    TagInputComponent.prototype.addItem = function (fromAutocomplete, item, index) {
        var _this = this;
        if (fromAutocomplete === void 0) { fromAutocomplete = false; }
        var /** @type {?} */ model = this.getItemDisplay(item);
        /**
         * \@name reset
         */
        var reset = function () {
            // reset control and focus input
            _this.setInputValue('');
            // focus input
            _this.focus(true, false);
        };
        /**
         * \@name validationFilter
         * @param tag
         */
        var validationFilter = function (tag) {
            var isValid = _this.isTagValid(tag, fromAutocomplete) && _this.inputForm.form.valid;
            if (!isValid) {
                _this.onValidationError.emit(tag);
            }
            return isValid;
        };
        /**
         * \@name subscribeFn
         * @param tag
         */
        var subscribeFn = function (tag) {
            _this.appendTag(tag, index);
            // emit event
            _this.onAdd.emit(tag);
            if (!_this.dropdown) {
                return;
            }
            _this.dropdown.hide();
            _this.dropdown.showDropdownIfEmpty ? _this.dropdown.show() : undefined;
        };
        Observable$1
            .of(model)
            .first()
            .filter(function () { return model.trim() !== ''; })
            .map(function () { return item; })
            .map(this.createTag)
            .filter(validationFilter)
            .subscribe(subscribeFn, undefined, reset);
    };
    /**
     * \@name setupSeparatorKeysListener
     * @return {?}
     */
    TagInputComponent.prototype.setupSeparatorKeysListener = function () {
        var _this = this;
        var /** @type {?} */ useSeparatorKeys = this.separatorKeyCodes.length > 0 || this.separatorKeys.length > 0;
        var /** @type {?} */ listener = function ($event) {
            var /** @type {?} */ hasKeyCode = _this.separatorKeyCodes.indexOf($event.keyCode) >= 0;
            var /** @type {?} */ hasKey = _this.separatorKeys.indexOf($event.key) >= 0;
            if (hasKeyCode || hasKey) {
                $event.preventDefault();
                _this.onAddingRequested(false, _this.formValue);
            }
        };
        listen.call(this, KEYDOWN, listener, useSeparatorKeys);
    };
    /**
     * \@name setUpKeypressListeners
     * @return {?}
     */
    TagInputComponent.prototype.setUpKeypressListeners = function () {
        var _this = this;
        var /** @type {?} */ listener = function ($event) {
            var /** @type {?} */ isCorrectKey = $event.keyCode === 37 || $event.keyCode === 8;
            if (isCorrectKey &&
                !_this.formValue &&
                _this.items.length) {
                _this.tags.last.select.call(_this.tags.last);
            }
        };
        // setting up the keypress listeners
        listen.call(this, KEYDOWN, listener);
    };
    /**
     * \@name setUpKeydownListeners
     * @return {?}
     */
    TagInputComponent.prototype.setUpInputKeydownListeners = function () {
        var _this = this;
        this.inputForm.onKeydown.subscribe(function (event) {
            _this.fireEvents('keydown', event);
            if (event.key === 'Backspace' && _this.formValue === '') {
                event.preventDefault();
            }
        });
    };
    /**
     * \@name setUpOnPasteListener
     * @return {?}
     */
    TagInputComponent.prototype.setUpOnPasteListener = function () {
        var /** @type {?} */ input = this.inputForm.input.nativeElement;
        // attach listener to input
        this.renderer.listen(input, 'paste', this.onPasteCallback);
    };
    /**
     * \@name setUpTextChangeSubscriber
     * @return {?}
     */
    TagInputComponent.prototype.setUpTextChangeSubscriber = function () {
        var _this = this;
        this.inputForm.form
            .valueChanges
            .debounceTime(this.onTextChangeDebounce)
            .map(function () { return _this.formValue; })
            .subscribe(function (value) { return _this.onTextChange.emit(value); });
    };
    /**
     * \@name setUpOnBlurSubscriber
     * @return {?}
     */
    TagInputComponent.prototype.setUpOnBlurSubscriber = function () {
        var _this = this;
        var /** @type {?} */ filterFn = function () {
            return !(_this.dropdown && _this.dropdown.isVisible) && !!_this.formValue;
        };
        this.inputForm
            .onBlur
            .filter(filterFn)
            .subscribe(function () {
            if (_this.addOnBlur) {
                _this.onAddingRequested(false, _this.formValue);
            }
            _this.setInputValue('');
        });
    };
    /**
     * \@name findDupe
     * @param {?} tag
     * @param {?} isFromAutocomplete
     * @return {?}
     */
    TagInputComponent.prototype.findDupe = function (tag, isFromAutocomplete) {
        var _this = this;
        var /** @type {?} */ identifyBy = isFromAutocomplete ? this.dropdown.identifyBy : this.identifyBy;
        var /** @type {?} */ id = tag[identifyBy];
        return this.items.find(function (item) { return _this.getItemValue(item) === id; });
    };
    /**
     * \@name setAnimationMetadata
     * @return {?}
     */
    TagInputComponent.prototype.setAnimationMetadata = function () {
        this.animationMetadata = {
            value: 'in',
            params: Object.assign({}, this.animationDuration)
        };
    };
    return TagInputComponent;
}(TagInputAccessor));
TagInputComponent.decorators = [
    { type: Component, args: [{
                selector: 'tag-input',
                providers: [CUSTOM_ACCESSOR],
                styles: ["\n      .dark tag:focus {\n        -webkit-box-shadow: 0 0 0 1px #323232;\n                box-shadow: 0 0 0 1px #323232; }\n\n      .ng2-tag-input.bootstrap3-info {\n        background-color: #fff;\n        display: inline-block;\n        color: #555;\n        vertical-align: middle;\n        max-width: 100%;\n        height: 42px;\n        line-height: 44px; }\n\n      .ng2-tag-input.bootstrap3-info input {\n        border: none;\n        -webkit-box-shadow: none;\n                box-shadow: none;\n        outline: none;\n        background-color: transparent;\n        padding: 0 6px;\n        margin: 0;\n        width: auto;\n        max-width: inherit; }\n\n      .ng2-tag-input.bootstrap3-info .form-control input::-moz-placeholder {\n        color: #777;\n        opacity: 1; }\n\n      .ng2-tag-input.bootstrap3-info .form-control input:-ms-input-placeholder {\n        color: #777; }\n\n      .ng2-tag-input.bootstrap3-info .form-control input::-webkit-input-placeholder {\n        color: #777; }\n\n      .ng2-tag-input.bootstrap3-info input:focus {\n        border: none;\n        -webkit-box-shadow: none;\n                box-shadow: none; }\n\n      .bootstrap3-info.ng2-tag-input.ng2-tag-input--focused {\n        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n                box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n        border: 1px solid #ccc; }\n\n      .bootstrap3-info.ng2-tag-input.ng2-tag-input--invalid {\n        -webkit-box-shadow: inset 0 1px 1px #d9534f;\n                box-shadow: inset 0 1px 1px #d9534f; }\n\n      .ng2-tag-input {\n        display: block;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        position: relative;\n        -webkit-transition: all 0.25s;\n        transition: all 0.25s;\n        padding: 0.25rem 0;\n        min-height: 32px;\n        cursor: text;\n        border-bottom: 2px solid #efefef; }\n        .ng2-tag-input:focus {\n          outline: 0; }\n        .ng2-tag-input.ng2-tag-input--dropping {\n          opacity: 0.7; }\n        .ng2-tag-input.ng2-tag-input--focused {\n          border-bottom: 2px solid #2196F3; }\n        .ng2-tag-input.ng2-tag-input--invalid {\n          border-bottom: 2px solid #f44336; }\n        .ng2-tag-input.ng2-tag-input--loading {\n          border: none; }\n        .ng2-tag-input.ng2-tag-input--disabled {\n          opacity: 0.5;\n          cursor: not-allowed; }\n        .ng2-tag-input form {\n          margin: 0.1em 0; }\n        .ng2-tag-input .ng2-tags-container {\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex; }\n\n      .minimal.ng2-tag-input {\n        display: block;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        position: relative;\n        cursor: text;\n        border-bottom: 1px solid transparent; }\n        .minimal.ng2-tag-input:focus {\n          outline: 0; }\n        .minimal.ng2-tag-input.ng2-tag-input--dropping {\n          opacity: 0.7; }\n        .minimal.ng2-tag-input.ng2-tag-input--loading {\n          border: none; }\n        .minimal.ng2-tag-input.ng2-tag-input--disabled {\n          opacity: 0.5;\n          cursor: not-allowed; }\n        .minimal.ng2-tag-input .ng2-tags-container {\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex; }\n\n      .dark.ng2-tag-input {\n        display: block;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        position: relative;\n        cursor: text;\n        border-bottom: 2px solid #444; }\n        .dark.ng2-tag-input:focus {\n          outline: 0; }\n        .dark.ng2-tag-input.ng2-tag-input--dropping {\n          opacity: 0.7; }\n        .dark.ng2-tag-input.ng2-tag-input--loading {\n          border: none; }\n        .dark.ng2-tag-input.ng2-tag-input--disabled {\n          opacity: 0.5;\n          cursor: not-allowed; }\n        .dark.ng2-tag-input .ng2-tags-container {\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex; }\n\n      .bootstrap.ng2-tag-input {\n        display: block;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        position: relative;\n        cursor: text;\n        border-bottom: 2px solid #efefef; }\n        .bootstrap.ng2-tag-input:focus {\n          outline: 0; }\n        .bootstrap.ng2-tag-input.ng2-tag-input--dropping {\n          opacity: 0.7; }\n        .bootstrap.ng2-tag-input.ng2-tag-input--focused {\n          border-bottom: 2px solid #0275d8; }\n        .bootstrap.ng2-tag-input.ng2-tag-input--invalid {\n          border-bottom: 2px solid #d9534f; }\n        .bootstrap.ng2-tag-input.ng2-tag-input--loading {\n          border: none; }\n        .bootstrap.ng2-tag-input.ng2-tag-input--disabled {\n          opacity: 0.5;\n          cursor: not-allowed; }\n        .bootstrap.ng2-tag-input .ng2-tags-container {\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex; }\n\n      .bootstrap3-info.ng2-tag-input {\n        display: block;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        position: relative;\n        padding: 4px;\n        cursor: text;\n        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n                box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n        border-radius: 4px; }\n        .bootstrap3-info.ng2-tag-input:focus {\n          outline: 0; }\n        .bootstrap3-info.ng2-tag-input.ng2-tag-input--dropping {\n          opacity: 0.7; }\n        .bootstrap3-info.ng2-tag-input.ng2-tag-input--invalid {\n          border-bottom: 1px solid #d9534f; }\n        .bootstrap3-info.ng2-tag-input.ng2-tag-input--loading {\n          border: none; }\n        .bootstrap3-info.ng2-tag-input.ng2-tag-input--disabled {\n          opacity: 0.5;\n          cursor: not-allowed; }\n        .bootstrap3-info.ng2-tag-input form {\n          margin: 0.1em 0; }\n        .bootstrap3-info.ng2-tag-input .ng2-tags-container {\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex; }\n\n      .error-message {\n        font-size: 0.8em;\n        color: #f44336;\n        margin: 0.5em 0 0 0; }\n\n      .bootstrap .error-message {\n        color: #d9534f; }\n\n      .progress-bar, .progress-bar:before {\n        height: 2px;\n        width: 100%;\n        margin: 0; }\n\n      .progress-bar {\n        background-color: #2196F3;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        position: absolute;\n        bottom: 0; }\n\n      .progress-bar:before {\n        background-color: #82c4f8;\n        content: '';\n        -webkit-animation: running-progress 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n        animation: running-progress 2s cubic-bezier(0.4, 0, 0.2, 1) infinite; }\n\n      @-webkit-keyframes running-progress {\n        0% {\n          margin-left: 0;\n          margin-right: 100%; }\n        50% {\n          margin-left: 25%;\n          margin-right: 0; }\n        100% {\n          margin-left: 100%;\n          margin-right: 0; } }\n\n      @keyframes running-progress {\n        0% {\n          margin-left: 0;\n          margin-right: 100%; }\n        50% {\n          margin-left: 25%;\n          margin-right: 0; }\n        100% {\n          margin-left: 100%;\n          margin-right: 0; } }\n\n      tag {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        font-family: \"Roboto\", \"Helvetica Neue\", sans-serif;\n        font-weight: 400;\n        font-size: 1em;\n        letter-spacing: 0.05rem;\n        color: #444;\n        border-radius: 16px;\n        -webkit-transition: all 0.3s;\n        transition: all 0.3s;\n        margin: 0.1rem 0.3rem 0.1rem 0;\n        padding: 0.08rem 0.45rem;\n        height: 32px;\n        line-height: 34px;\n        background: #efefef;\n        -webkit-user-select: none;\n           -moz-user-select: none;\n            -ms-user-select: none;\n                user-select: none;\n        overflow: hidden;\n        outline: 0;\n        cursor: pointer;\n        position: relative; }\n        tag:not(.readonly):not(.tag--editing):focus {\n          background: #2196F3;\n          color: #fff; }\n        tag:not(.readonly):not(.tag--editing):active {\n          background: #0d8aee;\n          color: #fff; }\n        tag:not(:focus):not(.tag--editing):not(:active):not(.readonly):hover {\n          background: #e2e2e2;\n          color: initial; }\n        tag.readonly {\n          cursor: default; }\n        tag.readonly:focus, tag:focus {\n          outline: 0; }\n        tag.tag--editing {\n          background-color: #fff;\n          border: 1px solid #ccc;\n          cursor: text; }\n\n      .minimal tag {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        border-radius: 0;\n        background: #f9f9f9;\n        -webkit-user-select: none;\n           -moz-user-select: none;\n            -ms-user-select: none;\n                user-select: none;\n        overflow: hidden;\n        outline: 0;\n        cursor: pointer;\n        position: relative; }\n        .minimal tag:not(.readonly):not(.tag--editing):focus {\n          background: #d0d0d0;\n          color: initial; }\n        .minimal tag:not(.readonly):not(.tag--editing):active {\n          background: #d0d0d0;\n          color: initial; }\n        .minimal tag:not(:focus):not(.tag--editing):not(:active):not(.readonly):hover {\n          background: #ececec; }\n        .minimal tag.readonly {\n          cursor: default; }\n        .minimal tag.readonly:focus, .minimal tag:focus {\n          outline: 0; }\n        .minimal tag.tag--editing {\n          cursor: text; }\n\n      .dark tag {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        color: #f9f9f9;\n        border-radius: 3px;\n        background: #444;\n        -webkit-user-select: none;\n           -moz-user-select: none;\n            -ms-user-select: none;\n                user-select: none;\n        overflow: hidden;\n        outline: 0;\n        cursor: pointer;\n        position: relative; }\n        .dark tag:not(.readonly):not(.tag--editing):focus {\n          background: #efefef;\n          color: #444; }\n        .dark tag:not(:focus):not(.tag--editing):not(:active):not(.readonly):hover {\n          background: #2b2b2b;\n          color: #f9f9f9; }\n        .dark tag.readonly {\n          cursor: default; }\n        .dark tag.readonly:focus, .dark tag:focus {\n          outline: 0; }\n        .dark tag.tag--editing {\n          cursor: text; }\n\n      .bootstrap tag {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        color: #f9f9f9;\n        border-radius: 0.25rem;\n        background: #0275d8;\n        -webkit-user-select: none;\n           -moz-user-select: none;\n            -ms-user-select: none;\n                user-select: none;\n        overflow: hidden;\n        outline: 0;\n        cursor: pointer;\n        position: relative; }\n        .bootstrap tag:not(.readonly):not(.tag--editing):focus {\n          background: #025aa5; }\n        .bootstrap tag:not(.readonly):not(.tag--editing):active {\n          background: #025aa5; }\n        .bootstrap tag:not(:focus):not(.tag--editing):not(:active):not(.readonly):hover {\n          background: #0267bf;\n          color: #f9f9f9; }\n        .bootstrap tag.readonly {\n          cursor: default; }\n        .bootstrap tag.readonly:focus, .bootstrap tag:focus {\n          outline: 0; }\n        .bootstrap tag.tag--editing {\n          cursor: text; }\n\n      .bootstrap3-info tag {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        font-family: inherit;\n        font-weight: 400;\n        font-size: 95%;\n        color: #fff;\n        border-radius: 0.25em;\n        background: #5bc0de;\n        -webkit-user-select: none;\n           -moz-user-select: none;\n            -ms-user-select: none;\n                user-select: none;\n        overflow: hidden;\n        outline: 0;\n        cursor: pointer;\n        position: relative;\n        padding: .25em .6em;\n        text-align: center;\n        white-space: nowrap; }\n        .bootstrap3-info tag:not(.readonly):not(.tag--editing):focus {\n          background: #28a1c5; }\n        .bootstrap3-info tag:not(.readonly):not(.tag--editing):active {\n          background: #28a1c5; }\n        .bootstrap3-info tag:not(:focus):not(.tag--editing):not(:active):not(.readonly):hover {\n          background: #46b8da;\n          color: #fff; }\n        .bootstrap3-info tag.readonly {\n          cursor: default; }\n        .bootstrap3-info tag.readonly:focus, .bootstrap3-info tag:focus {\n          outline: 0; }\n        .bootstrap3-info tag.tag--editing {\n          cursor: text; }\n\n      :host {\n        display: block; }\n    "],
                template: "\n      <!-- CONTAINER -->\n\n      <div ngClass=\"ng2-tag-input {{ theme || '' }}\"\n           (click)=\"focus(true, false)\"\n           [attr.tabindex]=\"-1\"\n\n           (drop)=\"dragZone ? onTagDropped($event, undefined) : undefined\"\n           (dragenter)=\"dragZone ? onDragOver($event) : undefined\"\n           (dragover)=\"dragZone ? onDragOver($event) : undefined\"\n           (dragend)=\"dragZone ? dragProvider.onDragEnd() : undefined\"\n\n           [class.ng2-tag-input--dropping]=\"isDropping()\"\n           [class.ng2-tag-input--disabled]=\"disable\"\n           [class.ng2-tag-input--loading]=\"isLoading\"\n           [class.ng2-tag-input--invalid]=\"hasErrors()\"\n           [class.ng2-tag-input--focused]=\"isInputFocused()\">\n\n          <!-- TAGS -->\n          <div class=\"ng2-tags-container\">\n              <tag *ngFor=\"let item of items; let i = index; trackBy: trackBy\"\n\n                   (onSelect)=\"selectItem(item)\"\n                   (onRemove)=\"onRemoveRequested(item, i)\"\n                   (onKeyDown)=\"handleKeydown($event)\"\n                   (onTagEdited)=\"onTagEdited.emit($event)\"\n                   (onBlur)=\"onTagBlurred($event, i)\"\n                   draggable=\"{{ editable }}\"\n\n                   (dragstart)=\"dragZone ? onDragStarted($event, item, i) : undefined\"\n                   (drop)=\"dragZone ? onTagDropped($event, i) : undefined\"\n                   (dragenter)=\"dragZone ? onDragOver($event) : undefined\"\n                   (dragover)=\"dragZone ? onDragOver($event, i) : undefined\"\n                   (dragleave)=\"dragZone ? dragProvider.onDragEnd() : undefined\"\n\n                   [attr.tabindex]=\"0\"\n                   [disabled]=\"disable\"\n                   [@animation]=\"animationMetadata\"\n                   [hasRipple]=\"ripple\"\n                   [index]=\"i\"\n                   [removable]=\"removable\"\n                   [editable]=\"editable\"\n                   [displayBy]=\"displayBy\"\n                   [identifyBy]=\"identifyBy\"\n                   [template]=\"!!hasCustomTemplate() ? templates.first : undefined\"\n                   [draggable]=\"dragZone\"\n                   [model]=\"item\">\n              </tag>\n\n              <tag-input-form\n                  (onSubmit)=\"onAddingRequested(false, formValue)\"\n                  (onBlur)=\"blur()\"\n                  (click)=\"dropdown ? dropdown.show() : undefined\"\n                  (onKeydown)=\"fireEvents('keydown', $event)\"\n                  (onKeyup)=\"fireEvents('keyup', $event)\"\n\n                  [(inputText)]=\"inputText\"\n                  [disabled]=\"disable\"\n                  [validators]=\"validators\"\n                  [asyncValidators]=\"asyncValidators\"\n                  [hidden]=\"maxItemsReached\"\n                  [placeholder]=\"items.length ? placeholder : secondaryPlaceholder\"\n                  [inputClass]=\"inputClass\"\n                  [inputId]=\"inputId\"\n                  [tabindex]=\"tabindex\">\n              </tag-input-form>\n          </div>\n\n          <div class=\"progress-bar\" *ngIf=\"isLoading\"></div>\n      </div>\n\n      <!-- ERRORS -->\n      <div *ngIf=\"hasErrors()\" class=\"error-messages {{ theme || '' }}\">\n          <p *ngFor=\"let error of inputForm.getErrorMessages(errorMessages)\" class=\"error-message\">\n              <span>{{ error }}</span>\n          </p>\n      </div>\n\n      <ng-content></ng-content>\n    ",
                animations: animations$1
            },] },
];
/**
 * @nocollapse
 */
TagInputComponent.ctorParameters = function () { return [
    { type: Renderer2, },
    { type: DragProvider, },
]; };
TagInputComponent.propDecorators = {
    'separatorKeys': [{ type: Input },],
    'separatorKeyCodes': [{ type: Input },],
    'placeholder': [{ type: Input },],
    'secondaryPlaceholder': [{ type: Input },],
    'maxItems': [{ type: Input },],
    'validators': [{ type: Input },],
    'asyncValidators': [{ type: Input },],
    'onlyFromAutocomplete': [{ type: Input },],
    'errorMessages': [{ type: Input },],
    'theme': [{ type: Input },],
    'onTextChangeDebounce': [{ type: Input },],
    'inputId': [{ type: Input },],
    'inputClass': [{ type: Input },],
    'clearOnBlur': [{ type: Input },],
    'hideForm': [{ type: Input },],
    'addOnBlur': [{ type: Input },],
    'addOnPaste': [{ type: Input },],
    'pasteSplitPattern': [{ type: Input },],
    'blinkIfDupe': [{ type: Input },],
    'removable': [{ type: Input },],
    'editable': [{ type: Input },],
    'allowDupes': [{ type: Input },],
    'modelAsStrings': [{ type: Input },],
    'trimTags': [{ type: Input },],
    'inputText': [{ type: Input },],
    'ripple': [{ type: Input },],
    'tabindex': [{ type: Input },],
    'disable': [{ type: Input },],
    'dragZone': [{ type: Input },],
    'onRemoving': [{ type: Input },],
    'onAdding': [{ type: Input },],
    'animationDuration': [{ type: Input },],
    'onAdd': [{ type: Output },],
    'onRemove': [{ type: Output },],
    'onSelect': [{ type: Output },],
    'onFocus': [{ type: Output },],
    'onBlur': [{ type: Output },],
    'onTextChange': [{ type: Output },],
    'onPaste': [{ type: Output },],
    'onValidationError': [{ type: Output },],
    'onTagEdited': [{ type: Output },],
    'dropdown': [{ type: ContentChild, args: [TagInputDropdown,] },],
    'templates': [{ type: ContentChildren, args: [TemplateRef, { descendants: false },] },],
    'inputForm': [{ type: ViewChild, args: [TagInputForm,] },],
    'tags': [{ type: ViewChildren, args: [TagComponent,] },],
    'inputTextChange': [{ type: Output },],
    'tabindexAttr': [{ type: HostBinding, args: ['attr.tabindex',] },],
};
var DeleteIconComponent = (function () {
    function DeleteIconComponent() {
    }
    return DeleteIconComponent;
}());
DeleteIconComponent.decorators = [
    { type: Component, args: [{
                selector: 'delete-icon',
                template: "\n      <span>\n          <svg height=\"16px\" viewBox=\"0 0 32 32\" width=\"16px\">\n              <path d=\"M17.459,16.014l8.239-8.194c0.395-0.391,0.395-1.024,0-1.414c-0.394-0.391-1.034-0.391-1.428,0  l-8.232,8.187L7.73,6.284c-0.394-0.395-1.034-0.395-1.428,0c-0.394,0.396-0.394,1.037,0,1.432l8.302,8.303l-8.332,8.286  c-0.394,0.391-0.394,1.024,0,1.414c0.394,0.391,1.034,0.391,1.428,0l8.325-8.279l8.275,8.276c0.394,0.395,1.034,0.395,1.428,0  c0.394-0.396,0.394-1.037,0-1.432L17.459,16.014z\"\n                    fill=\"#121313\" />\n          </svg>\n      </span>\n    ",
                styles: ["\n      .dark tag:focus {\n        -webkit-box-shadow: 0 0 0 1px #323232;\n                box-shadow: 0 0 0 1px #323232; }\n\n      .ng2-tag-input.bootstrap3-info {\n        background-color: #fff;\n        display: inline-block;\n        color: #555;\n        vertical-align: middle;\n        max-width: 100%;\n        height: 42px;\n        line-height: 44px; }\n\n      .ng2-tag-input.bootstrap3-info input {\n        border: none;\n        -webkit-box-shadow: none;\n                box-shadow: none;\n        outline: none;\n        background-color: transparent;\n        padding: 0 6px;\n        margin: 0;\n        width: auto;\n        max-width: inherit; }\n\n      .ng2-tag-input.bootstrap3-info .form-control input::-moz-placeholder {\n        color: #777;\n        opacity: 1; }\n\n      .ng2-tag-input.bootstrap3-info .form-control input:-ms-input-placeholder {\n        color: #777; }\n\n      .ng2-tag-input.bootstrap3-info .form-control input::-webkit-input-placeholder {\n        color: #777; }\n\n      .ng2-tag-input.bootstrap3-info input:focus {\n        border: none;\n        -webkit-box-shadow: none;\n                box-shadow: none; }\n\n      .bootstrap3-info.ng2-tag-input.ng2-tag-input--focused {\n        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n                box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n        border: 1px solid #ccc; }\n\n      .bootstrap3-info.ng2-tag-input.ng2-tag-input--invalid {\n        -webkit-box-shadow: inset 0 1px 1px #d9534f;\n                box-shadow: inset 0 1px 1px #d9534f; }\n\n      .ng2-tag-input {\n        display: block;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        position: relative;\n        -webkit-transition: all 0.25s;\n        transition: all 0.25s;\n        padding: 0.25rem 0;\n        min-height: 32px;\n        cursor: text;\n        border-bottom: 2px solid #efefef; }\n        .ng2-tag-input:focus {\n          outline: 0; }\n        .ng2-tag-input.ng2-tag-input--dropping {\n          opacity: 0.7; }\n        .ng2-tag-input.ng2-tag-input--focused {\n          border-bottom: 2px solid #2196F3; }\n        .ng2-tag-input.ng2-tag-input--invalid {\n          border-bottom: 2px solid #f44336; }\n        .ng2-tag-input.ng2-tag-input--loading {\n          border: none; }\n        .ng2-tag-input.ng2-tag-input--disabled {\n          opacity: 0.5;\n          cursor: not-allowed; }\n        .ng2-tag-input form {\n          margin: 0.1em 0; }\n        .ng2-tag-input .ng2-tags-container {\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex; }\n\n      .minimal.ng2-tag-input {\n        display: block;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        position: relative;\n        cursor: text;\n        border-bottom: 1px solid transparent; }\n        .minimal.ng2-tag-input:focus {\n          outline: 0; }\n        .minimal.ng2-tag-input.ng2-tag-input--dropping {\n          opacity: 0.7; }\n        .minimal.ng2-tag-input.ng2-tag-input--loading {\n          border: none; }\n        .minimal.ng2-tag-input.ng2-tag-input--disabled {\n          opacity: 0.5;\n          cursor: not-allowed; }\n        .minimal.ng2-tag-input .ng2-tags-container {\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex; }\n\n      .dark.ng2-tag-input {\n        display: block;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        position: relative;\n        cursor: text;\n        border-bottom: 2px solid #444; }\n        .dark.ng2-tag-input:focus {\n          outline: 0; }\n        .dark.ng2-tag-input.ng2-tag-input--dropping {\n          opacity: 0.7; }\n        .dark.ng2-tag-input.ng2-tag-input--loading {\n          border: none; }\n        .dark.ng2-tag-input.ng2-tag-input--disabled {\n          opacity: 0.5;\n          cursor: not-allowed; }\n        .dark.ng2-tag-input .ng2-tags-container {\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex; }\n\n      .bootstrap.ng2-tag-input {\n        display: block;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        position: relative;\n        cursor: text;\n        border-bottom: 2px solid #efefef; }\n        .bootstrap.ng2-tag-input:focus {\n          outline: 0; }\n        .bootstrap.ng2-tag-input.ng2-tag-input--dropping {\n          opacity: 0.7; }\n        .bootstrap.ng2-tag-input.ng2-tag-input--focused {\n          border-bottom: 2px solid #0275d8; }\n        .bootstrap.ng2-tag-input.ng2-tag-input--invalid {\n          border-bottom: 2px solid #d9534f; }\n        .bootstrap.ng2-tag-input.ng2-tag-input--loading {\n          border: none; }\n        .bootstrap.ng2-tag-input.ng2-tag-input--disabled {\n          opacity: 0.5;\n          cursor: not-allowed; }\n        .bootstrap.ng2-tag-input .ng2-tags-container {\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex; }\n\n      .bootstrap3-info.ng2-tag-input {\n        display: block;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: row;\n                flex-direction: row;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        position: relative;\n        padding: 4px;\n        cursor: text;\n        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n                box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n        border-radius: 4px; }\n        .bootstrap3-info.ng2-tag-input:focus {\n          outline: 0; }\n        .bootstrap3-info.ng2-tag-input.ng2-tag-input--dropping {\n          opacity: 0.7; }\n        .bootstrap3-info.ng2-tag-input.ng2-tag-input--invalid {\n          border-bottom: 1px solid #d9534f; }\n        .bootstrap3-info.ng2-tag-input.ng2-tag-input--loading {\n          border: none; }\n        .bootstrap3-info.ng2-tag-input.ng2-tag-input--disabled {\n          opacity: 0.5;\n          cursor: not-allowed; }\n        .bootstrap3-info.ng2-tag-input form {\n          margin: 0.1em 0; }\n        .bootstrap3-info.ng2-tag-input .ng2-tags-container {\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex; }\n\n      .error-message {\n        font-size: 0.8em;\n        color: #f44336;\n        margin: 0.5em 0 0 0; }\n\n      .bootstrap .error-message {\n        color: #d9534f; }\n\n      :host(delete-icon) {\n        width: 20px;\n        height: 16px;\n        -webkit-transition: all 0.15s;\n        transition: all 0.15s;\n        display: inline-block;\n        text-align: right; }\n        :host(delete-icon) path {\n          fill: #444; }\n        :host(delete-icon) svg {\n          vertical-align: bottom;\n          height: 34px; }\n\n      :host(delete-icon):hover {\n        -webkit-transform: scale(1.5) translateY(-3px);\n                transform: scale(1.5) translateY(-3px); }\n\n      :host-context(.dark) {\n        text-align: right; }\n        :host-context(.dark) path {\n          fill: #fff; }\n        :host-context(.dark) svg {\n          vertical-align: bottom;\n          height: 34px; }\n\n      :host-context(.minimal) {\n        text-align: right; }\n        :host-context(.minimal) path {\n          fill: #444; }\n        :host-context(.minimal) svg {\n          vertical-align: bottom;\n          height: 34px; }\n\n      :host-context(.bootstrap) {\n        text-align: right; }\n        :host-context(.bootstrap) path {\n          fill: #fff; }\n        :host-context(.bootstrap) svg {\n          vertical-align: bottom;\n          height: 34px; }\n\n      :host-context(tag:focus) path,\n      :host-context(tag:active) path {\n        fill: #fff; }\n\n      :host-context(.dark tag:focus) path,\n      :host-context(.dark tag:active) path {\n        fill: #000; }\n\n      :host-context(.minimal tag:focus) path,\n      :host-context(.minimal tag:active) path {\n        fill: #000; }\n\n      :host-context(.bootstrap tag:focus) path,\n      :host-context(.bootstrap tag:active) path {\n        fill: #fff; }\n\n      :host-context(.bootstrap3-info) {\n        height: inherit; }\n        :host-context(.bootstrap3-info) path {\n          fill: #fff; }\n    "]
            },] },
];
/**
 * @nocollapse
 */
DeleteIconComponent.ctorParameters = function () { return []; };
var optionsProvider = new OptionsProvider();
var TagInputModule = (function () {
    function TagInputModule() {
    }
    /**
     * \@name withDefaults
     * @param {?} options {Options}
     * @return {?}
     */
    TagInputModule.withDefaults = function (options) {
        optionsProvider.setOptions(options);
    };
    return TagInputModule;
}());
TagInputModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    FormsModule,
                    Ng2DropdownModule
                ],
                declarations: [
                    TagInputComponent,
                    DeleteIconComponent,
                    TagInputForm,
                    TagComponent,
                    HighlightPipe,
                    TagInputDropdown,
                    TagRipple
                ],
                exports: [
                    TagInputComponent,
                    DeleteIconComponent,
                    TagInputForm,
                    TagComponent,
                    HighlightPipe,
                    TagInputDropdown,
                    TagRipple
                ],
                providers: [
                    DragProvider,
                    { provide: COMPOSITION_BUFFER_MODE, useValue: false },
                ]
            },] },
];
/**
 * @nocollapse
 */
TagInputModule.ctorParameters = function () { return []; };
/**
 * Generated bundle index. Do not edit.
 */
export { TagInputModule, TagInputDropdown, DeleteIconComponent, TagInputForm, TagRipple, TagComponent, TagInputComponent, TagInputDropdown as ɵd, DeleteIconComponent as ɵi, TagInputForm as ɵe, animations$1 as ɵc, TagInputComponent as ɵa, TagRipple as ɵg, TagComponent as ɵf, TagInputAccessor as ɵb, HighlightPipe as ɵj, DragProvider as ɵh };
//# sourceMappingURL=ngx-chips.es5.js.map



//////////////////
// WEBPACK FOOTER
// ./~/ngx-chips/ngx-chips.es5.js
// module id = 1545
// module chunks = 21